import Divider from "@components/common/Divider";
import StrapiContent from "@components/common/StrapiContent";
import IncludedPackages from "@components/packageComponents/IncludedPackages";
import { sortPackagesAndLocations } from "@components/utils/sortingHelpers";
import { useMemo } from "react";
import DetailsPageReviewsSection from "../common/DetailsPageReviewsSection";

interface IAccommodationOrActivityPageMainSection {
  data: any;
  allPackages: any;
  allLocations: any;
  pageType: "accommodation" | "activity" | "package";
}

const AccommodationOrActivityPageMainSection = ({
  data,
  allPackages,
  allLocations,
  pageType,
}: IAccommodationOrActivityPageMainSection): JSX.Element => {
  const packages = useMemo(() => {
    const packages = [];
    for (const packageKey in allPackages) {
      const packageId = allPackages[packageKey].id;
      for (const key in data.packages) {
        const taglessPackageId = data.packages[key].id;
        if (taglessPackageId === packageId) {
          packages.push({
            ...allPackages[packageKey],
            isMultiDestinationsPackage: true,
          });
        }
      }
    }

    for (const locationKey in allLocations) {
      const locationId = allLocations[locationKey].id;
      for (const key in data.locations) {
        const taglessLocationId = data.locations[key].id;
        if (taglessLocationId === locationId) {
          packages.push({
            ...allLocations[locationKey],
            isMultiDestinationsPackage: false,
          });
        }
      }
    }
    return sortPackagesAndLocations(
      packages,
      undefined,
      "multiDestinationsPackage"
    );
  }, [allPackages, allLocations]);

  return (
    <>
      <div className="w-full">
        <Divider variant="short" />
      </div>
      <IncludedPackages
        packages={packages}
        title={data.Title}
        collectionType={pageType}
        locationTitle={data.locations[0]?.Title}
        cardsToShow={2}
      />
      <div className="w-full">
        <Divider variant="short" />
      </div>
      <div className="px-5 pt-4 desktop:mt-8 desktop:block desktop:p-0">
        <div className="mb-12 w-[100%] desktop:mb-[2.5rem]">
          <div className="text-p14 text-darkgray desktop:text-p">
            <StrapiContent
              overview={""}
              description={data.Long_Description}
            />
          </div>
        </div>
      </div>
      {/* REVIEWS START */}
      {data.reviews.length > 0 && (
        <>
          <div className="w-full">
            <Divider variant="short" />
          </div>
          <DetailsPageReviewsSection
            reviewsData={data.reviews}
            title={data.Title}
          />
        </>
      )}
    </>
  );
};

export default AccommodationOrActivityPageMainSection;
